/* section-footer.js — extracted from sections/footer.liquid */
  function initFooterSection() {
    let btn = document.getElementById('back-to-top');
    if (!btn) return;

    let SHOW_THRESHOLD = 400;

    let onScroll = function () {
      btn.hidden = window.scrollY < SHOW_THRESHOLD;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    /* On mobile: close all footer accordions on scroll to avoid layout shift */
    if (window.innerWidth < 769) {
      document.querySelectorAll('.footer__menu-details').forEach(function (el) {
        el.removeAttribute('open');
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterSection);
  } else {
    initFooterSection();
  }

  document.addEventListener('shopify:section:load', function(ev) {
    initFooterSection();
  });
